// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenMessages = (nestedMessages: any, prefix = '') => {
    if (nestedMessages === null) {
        return {};
    }

    return Object.keys(nestedMessages).reduce((messages, key) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
        const value = nestedMessages[key];
        const prefixedKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'string') {
            Object.assign(messages, { [prefixedKey]: value });
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
};

export const getFromLSObject = (lsObjName: string, attr?: string) => {
    const lsObj = (JSON.parse(window.localStorage.getItem(lsObjName) as string) || {}) as Record<string, unknown>;

    return attr ? lsObj[attr] : lsObj;
};

export function addToLSObject<V>(lsObjName: string, attr: string | null, val: V): void | boolean {
    let lsObj: Record<string, V> | V = (JSON.parse(window.localStorage.getItem(lsObjName) as string) || {}) as Record<
        string,
        V
    >;

    if (attr) {
        lsObj[attr] = val;
    } else {
        lsObj = val;
    }

    try {
        window.localStorage.setItem(lsObjName, JSON.stringify(lsObj));
    } catch (error) {
        console.warn('Error when adding to LS', error);

        return false;
    }
}

export function getParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;

    const nameParsed = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + nameParsed + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
